import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { Record } from '../../core/models/record.model';

export const loadRecords = createAction(
  '[Record] Load Records',
  props<{ records: Record[] }>()
);

export const addRecord = createAction(
  '[Record] Add Record',
  props<{ record: Record }>()
);

export const upsertRecord = createAction(
  '[Record] Upsert Record',
  props<{ record: Record }>()
);

export const addRecords = createAction(
  '[Record] Add Records',
  props<{ records: Record[] }>()
);

export const upsertRecords = createAction(
  '[Record] Upsert Records',
  props<{ records: Record[] }>()
);

export const updateRecord = createAction(
  '[Record] Update Record',
  props<{ record: Update<Record> }>()
);

export const updateRecords = createAction(
  '[Record] Update Records',
  props<{ records: Update<Record>[] }>()
);

export const deleteRecord = createAction(
  '[Record] Delete Record',
  props<{ id: string }>()
);

export const deleteRecords = createAction(
  '[Record] Delete Records',
  props<{ ids: string[] }>()
);

export const clearRecords = createAction(
  '[Record] Clear Records'
);
